// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.inputargs.DateFilterOperation
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSEnum.vm
// If you need to 'extend' the enum, create another file with module of the same name and add functions to it...

export let DateFilterOperation = /*#__PURE__*/function (DateFilterOperation) {
  DateFilterOperation[DateFilterOperation["None"] = 0] = "None";
  DateFilterOperation[DateFilterOperation["Equal"] = 1] = "Equal";
  DateFilterOperation[DateFilterOperation["Before"] = 2] = "Before";
  DateFilterOperation[DateFilterOperation["After"] = 3] = "After";
  DateFilterOperation[DateFilterOperation["Between"] = 4] = "Between";
  DateFilterOperation[DateFilterOperation["Latest"] = 5] = "Latest";
  DateFilterOperation[DateFilterOperation["Specified"] = 6] = "Specified";
  return DateFilterOperation;
}({});
(function (_DateFilterOperation) {
  function fromJson(enumVal) {
    // Canonically always return numeric representation of enum (NOT a string!)
    // An enumVal of either string or number will return undefined if invalid (out of range)
    return typeof enumVal === "number"
    // For safety, check for number in range, if not return undefined
    ? DateFilterOperation[enumVal] != null ? enumVal : undefined : DateFilterOperation[enumVal];
  }
  _DateFilterOperation.fromJson = fromJson;
  function name(enumIndex) {
    return this[enumIndex];
  }
  _DateFilterOperation.name = name;
  function indexOf(enumVal) {
    return enumVal; // Erasure....
  }
  _DateFilterOperation.indexOf = indexOf;
})(DateFilterOperation || (DateFilterOperation = {}));
//# sourceMappingURL=DateFilterOperation.js.map
